import { Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import { AuthService} from '../core/authentication/auth.service';
import { Router} from '@angular/router';
import { User } from '../core/authentication/User';
import { ConfigService } from '../core/services/config.service';
import { Roles } from '../shared/model/Roles';
import { Abilities } from '../shared/model/Abilities';
import { UserProfile } from '../core/authentication/UserProfile';
import { ReferenceType } from '../shared/model/ReferenceType';
import { environment } from 'src/environments/environment';
import { MediaService } from '../shared/services/media.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @ViewChild("anchor", { static: false })
  public anchor: ElementRef<HTMLElement>;
  
  userEmployeeProfile: UserProfile;
  user:User;
  isAccountingUser: boolean;
  hasAdminPanelAccess: boolean;
  hasServicePanelAccess: boolean;

  showUserMenu: boolean;
  profileReferenceType: string;

  sessionValidTime: Date;
  currentTime: Date;
  brand: string;

  isTrainingEnv: boolean;

  showPopupMenu: boolean

  @ViewChild("menuAnchor", { static: false })
  public menuAnchor: ElementRef<HTMLElement>;

  @HostListener("click", ["$event"])
  public documentClick(event: MouseEvent): void {
    if (this.showPopupMenu && !this.menuAnchor.nativeElement.contains(event.target as Node)) {
      this.togglePopupMenu();
    }
  }

  constructor(
    private authService: AuthService, 
    private configService: ConfigService,
    private router: Router,
    public mediaService: MediaService) {
      this.brand = environment.brand;
      this.isTrainingEnv = environment.isTrainingEnv;
  }

  ngOnInit(): void {
    this.user = this.authService.getLoggedUserInfo();
    this.userEmployeeProfile = this.user.getLoggedUserProfile(ReferenceType.Employee);
    this.isAccountingUser = this.authService.hasRole(Roles.AccountingUser);
    this.hasAdminPanelAccess = this.authService.hasRole(Roles.SuperAdmin) || this.authService.hasAbility(Abilities.AdminPanelAccess);
    this.hasServicePanelAccess = this.authService.hasRole(Roles.SuperAdmin) || this.authService.hasAbility(Abilities.ServicePanelAccess);


    this.sessionValidTime = this.authService.tokenExpirationTime();
    this.currentTime = new Date();

    //if empty root retrieved dispatch-profile
    if(this.router.url == '/'){
      this.router.navigate(['dispatch-profile']);
    }
  }

  logoutUser(): void {
    this.authService.logout();
  }

  showUserProfile(){
    this.showUserMenu = true;
  }

  reportBug(){
    window.open(this.configService.issuesPortalUrl, "_blank");
  }

  getAccountingLink(){

    if(this.authService.hasAbility(Abilities.AccountingInternalCostInvoiceCanManage)){
      this.router.navigate(['./accountingCenter/internalCostInvoices']);
      return;
    }

    if(this.authService.hasAbility(Abilities.AccountingCostInvoiceCanManage)){
      this.router.navigate(['./accountingCenter/costInvoices']);
      return;
    }

    if(this.authService.hasAbility(Abilities.AccountingCostReportCanManage)){
      this.router.navigate(['./accountingCenter/costsReportData/search']);
      return;
    }

    this.router.navigate(['./not-authorized']);
   
  }

  togglePopupMenu() {
    this.showPopupMenu = !this.showPopupMenu;
  }
}
